/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-06
 */

import { Component,OnInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { LayoutBaseComponent } from '../layout-base.component';


@Component({
      selector: 'header-x',
      templateUrl: './header-x.component.html',
      styleUrls: ['./header-x.component.less']
})
export class HeaderXComponent extends LayoutBaseComponent {

      constructor(private elRef:ElementRef) {
            super();
            this.inputStyle = "right: 0.2em";
       }


      public get inputClass():string {
            return "vis-icon glyphicon glyphicon-remove "+this.input_class;
      }

      public get labelClass():string {
            return this.label_class;
      }

      public get className():string {
             return "outer-box "+this.class_name;
      }

      @Output('close')   clickHandler  = new EventEmitter<string>();

      public onClick() {
             this.clickHandler.emit();
      }

      public keyPress(event:any) {
            if ( event.keyCode == 13 ) {
                 this.onClick();        
            }
     }
}
